import { Controller } from "@hotwired/stimulus"
import { buildLocalizedUrl } from "../lib/locale"

// 챗봇 컨트롤러 - 챗봇 테스트 및 메시지 전송 기능을 담당
export default class extends Controller {
  static values = {
    id: Number,
    loadingText: String,
    errorPrefix: String,
    genericError: String
  }
  
  connect() {
    console.log("Chatbot controller connected", this.idValue);
    this.chatInput = this.element.querySelector('#chat-input');
    this.sendButton = this.element.querySelector('#send-button');
    this.chatMessages = this.element;
    this.chatResponses = this.element.querySelector('#chat-responses');
  }
  
  // 키보드 이벤트 핸들러
  handleKeydown(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }
  
  // 메시지 전송
  sendMessage() {
    const message = this.chatInput.value.trim();
    if (!message) return;
    
    this.addUserMessage(message);
    this.chatInput.value = '';
    this.addLoadingMessage();
    
    fetch(buildLocalizedUrl(`/chatbots/${this.idValue}/generate`), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ message })
    })
    .then(response => response.json())
    .then(data => {
      this.removeLoadingMessage();
      if (data.error) {
        const prefix = this.errorPrefixValue || 'Error:'
        this.addBotMessage(`${prefix} ${data.error}`);
      } else {
        this.addBotMessage(data.message);
      }
    })
    .catch(error => {
      this.removeLoadingMessage();
      this.addBotMessage(this.genericErrorValue || 'Something went wrong. Please try again.');
      console.error('Error:', error);
    });
  }
  
  // 사용자 메시지 추가
  addUserMessage(message) {
    const messageHtml = `
      <div class="flex items-start justify-end mb-4">
        <div class="mr-3 bg-blue-500 rounded-lg py-2 px-3 max-w-3/4">
          <p class="text-sm text-white">${message}</p>
        </div>
        <div class="flex-shrink-0 bg-blue-100 rounded-full p-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
      </div>
    `;
    this.chatResponses.insertAdjacentHTML('beforeend', messageHtml);
    this.chatMessages.scrollTop = this.chatMessages.scrollHeight;
  }
  
  // 봇 메시지 추가
  addBotMessage(message) {
    const messageHtml = `
      <div class="flex items-start mb-4">
        <div class="flex-shrink-0 bg-indigo-100 rounded-full p-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        <div class="ml-3 bg-indigo-50 rounded-lg py-2 px-3 max-w-3/4">
          <p class="text-sm text-gray-800">${message}</p>
        </div>
      </div>
    `;
    this.chatResponses.insertAdjacentHTML('beforeend', messageHtml);
    this.chatMessages.scrollTop = this.chatMessages.scrollHeight;
  }
  
  // 로딩 메시지 추가
  addLoadingMessage() {
    const text = this.loadingTextValue || 'Loading'
    const loadingHtml = `
      <div class="flex items-start mb-4" id="loading-message">
        <div class="flex-shrink-0 bg-indigo-100 rounded-full p-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        <div class="ml-3 bg-indigo-50 rounded-lg py-2 px-3 max-w-3/4">
          <p class="text-sm text-gray-800 flex items-center">
            <span class="mr-2">${text}</span>
            <span class="flex">
              <span class="animate-bounce mx-0.5 h-1 w-1 bg-indigo-600 rounded-full"></span>
              <span class="animate-bounce mx-0.5 h-1 w-1 bg-indigo-600 rounded-full" style="animation-delay: 0.2s"></span>
              <span class="animate-bounce mx-0.5 h-1 w-1 bg-indigo-600 rounded-full" style="animation-delay: 0.4s"></span>
            </span>
          </p>
        </div>
      </div>
    `;
    this.chatResponses.insertAdjacentHTML('beforeend', loadingHtml);
    this.chatMessages.scrollTop = this.chatMessages.scrollHeight;
  }
  
  // 로딩 메시지 제거
  removeLoadingMessage() {
    const loadingMessage = document.getElementById('loading-message');
    if (loadingMessage) {
      loadingMessage.remove();
    }
  }
}
